class FileSystem {
	static addImages() {}
	static addFolder() {}
	static selectFolder() {}
}

export default FileSystem;
